import { BLACK, NEUTRAL_100 } from "../../styles/colors";
import { INTER } from "../../styles/fonts";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 16px;
  gap: 16px;
  border-bottom: 1px solid ${NEUTRAL_100};
`;

export const DepositAddressLabel = styled.span`
  color: ${BLACK};
  font-family: ${INTER.semiBold};
`;

export const DepositAddressContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const DepositAddress = styled.span`
  color: ${BLACK};
  font-family: ${INTER.medium};
  word-break: break-word;
  white-space: pre-wrap;
  width: 80%;
`;

export const CopyButtonContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 100%;
  cursor: pointer;
  appearance: none;
  aspect-ratio: 1/1;
  max-width: 48px;
  max-height: 48px;
  padding: 8px;
  border-width: 1px;
  border-style: solid;
  border-color: transparent;
`;
